import config from '@/others/interface';
import {$get, $post, } from '@/others/ajax';

export default {
  namespaced: true,
  state: {
    articleDetails: null,
    relevantList: [],
    prevnext: [],
  },
  mutations: {
    setDetail (state, data) {
      state.articleDetails = data.data;
      state.relevantList = data.recom;
      state.prevnext = data.prevnext;
      console.log(data.data, 'data.data');
    },
  },
  actions: {
    getDetail ({state, commit, dispatch, }, data) {
      $get(`${config.zmlgw}/web/getDetail?articleid=${data.id}&wordKey=${data.KeyWord}&secondColumnId=${data.secondColumnId}`)
        .then((res) => {
          if (res.code == 200) {
            commit('setDetail', res.data);
          }
        });// 文章详情接口
    },

  },
};



// WEBPACK FOOTER //
// src/store/articleDetails/articleDetails.js